import { MerchFlowCoreRange } from "../merchandise";

export const RoutePostMerchflowsImportPlanogramsFromPsa = "/merchflows/import-planograms-from-psa";

export interface PayloadFormPostMerchflowsImportPlanogramsFromPsa {
  psaFiles: File[];
  merchflowName: string;
  notes?: string;
  goLiveDate: string;
  coreRangeOption: MerchFlowCoreRange;
  deactivationDate?: string | null;
  /** Sub-Category on UI */
  categoryCode: string;
  /** Category on UI, category_group in DB */
  retailerCategoryCode: string;
}

export type PayloadPostMerchflowsImportPlanogramsFromPsa = FormData;

export interface ResponsePostMerchflowsImportPlanogramsFromPsa {
  merchflow_id: number;
  merchflow_name: string;
  total_stores: number;
  successful_stores: number;
  failed_stores: number;
  store_results: Array<{
    store_code: string;
    file_name: string;
    status: "SUCCESS" | "ERROR";
    error?: string;
    product_sync?: {
      products_not_found: number;
      products_updated: number;
      fields_updated: number;
    };
  }>;
}
